import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import { Link } from 'react-router-dom';
import * as Styles from './SeminarCard.styles';

export type SeminarCardProps = {
  thumbnail: string;
  authorPicture: string;
  title: string;
  authorName: string;
  publishedAt: string;
  link: string;
};

const SeminarCard = ({
  thumbnail,
  authorPicture,
  title,
  authorName,
  link,
  publishedAt,
  ...props
}: SeminarCardProps): JSX.Element => {
  return (
    <Styles.Card data-testid="seminar-card" {...props}>
      <Link to={link}>
        <Styles.Figure data-testid="seminar-thumbnail">
          <img src={thumbnail} alt="" />
          <PlayArrowIcon fontSize="large" />
        </Styles.Figure>
      </Link>
      <Link to={link} data-testid="seminar-link">
        <Styles.Title>{title}</Styles.Title>
      </Link>
      <Styles.Author data-testid="seminar-author">
        <Styles.AuthorImage data-testid="seminar-author-image" src={authorPicture} alt="" />
        <div>
          <Styles.AuthorName data-testid="seminar-author-name">{authorName}</Styles.AuthorName>
          {publishedAt && (
            <Styles.PublishedAt data-testid="seminar-date">{publishedAt}</Styles.PublishedAt>
          )}
        </div>
      </Styles.Author>
    </Styles.Card>
  );
};

export default SeminarCard;
